export type AnalyticsPlatform = 'ios' | 'android'

export const ANALYTICS_PLATFORMS: AnalyticsPlatform[] = ['ios', 'android']

export interface ScanPoint {
    date: string
    count: number
}

export interface ScansResponse {
    total_scans: number
    unique_scans: number
    total_clicks: number | null
    scans_over_time: ScanPoint[]
}

export interface ScansParams {
    from?: string
    to?: string
    platform?: AnalyticsPlatform
}

export interface ScanEvent {
    id: number
    timestamp: string
    platform?: AnalyticsPlatform | null
    city?: string | null
    state?: string | null
    country?: string | null
}

export interface ScansListResponse {
    items: ScanEvent[]
    total: number
}

export interface ScansListParams extends ScansParams {
    page?: number
    limit?: number
}
